import { Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BaseSiteService, ConsentService, CxEvent } from '@spartacus/core';
import { TmsCollector, WindowObject } from '@spartacus/tracking/tms/core';
import { combineLatest } from 'rxjs';
import { FbqCollectorConfig } from './config/fbq-collector.config';
import { EnvironmentService } from './environment.service';

declare let fbq: Function;

@Injectable({
  providedIn: 'root',
})
export class FbqCollectorService implements TmsCollector {
  constructor(
    private environmentService: EnvironmentService,
    private consentService: ConsentService,
    private baseSiteService: BaseSiteService
  ) {
    window['fbqViewContent'] = false;
    window['fbqSearch'] = false;
    window['fbqPurchase'] = false;
    window['fbqAddToCart'] = false;
    window['fbqAddPaymentInfo'] = false;
    window['fbqCompleteRegistration'] = false;
    window['fbqContact'] = false;
    window['fbqInitiateCheckout'] = false;
  }

  consentCookie$ = this.consentService.checkConsentGivenByTemplateId('ANALYTICS');

  init(config: FbqCollectorConfig, windowObject: WindowObject): void {
    combineLatest([this.consentCookie$, this.baseSiteService.getActive()])
      .pipe(takeUntilDestroyed())
      .subscribe(([analyticsAllowed, activeSiteId]) => {
        const fbqId: string | undefined = activeSiteId
          ? this.environmentService.getCurrentEnvironment().tracking.facebook.pixel.id[activeSiteId]
          : undefined;

        if (analyticsAllowed && fbqId) {
          const splittedFbqId = fbqId.split(';');

          // @ts-ignore
          !(function (f: WindowObject, b: Document, e: string, v: string, n: any, t: any, s: any) {
            if (f['fbq']) return;
            n = f['fbq'] = function () {
              n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
            };
            if (!f['_fbq']) f['_fbq'] = n;
            n.push = n;
            n.loaded = !0;
            n.version = '2.0';
            n.queue = [];
            t = b.createElement(e);
            t.async = !0;
            t.src = v;
            s = b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t, s);
          })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', splittedFbqId[0]);
          fbq('track', 'PageView');

          for (let i = 1; i < splittedFbqId.length; i++) {
            if (splittedFbqId[i] === 'ViewContent') {
              window['fbqViewContent'] = true;
            } else if (splittedFbqId[i] === 'Search') {
              window['fbqSearch'] = true;
            } else if (splittedFbqId[i] === 'Purchase') {
              window['fbqPurchase'] = true;
            } else if (splittedFbqId[i] === 'AddToCart') {
              window['fbqAddToCart'] = true;
            } else if (splittedFbqId[i] === 'AddPaymentInfo') {
              window['fbqAddPaymentInfo'] = true;
            } else if (splittedFbqId[i] === 'CompleteRegistration') {
              window['fbqCompleteRegistration'] = true;
            } else if (splittedFbqId[i] === 'Contact') {
              window['fbqContact'] = true;
            } else if (splittedFbqId[i] === 'InitiateCheckout') {
              window['fbqInitiateCheckout'] = true;
            }
          }
        }
      });
  }

  pushEvent<T extends CxEvent>(config: FbqCollectorConfig, windowObject: WindowObject, event: any): void {
    if (event.event && window['fbq' + event.event]) {
      if (event.parameters) {
        fbq('track', event.event, event.parameters);
      } else {
        fbq('track', event.event);
      }
    }
  }
}
